// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DelegowanieZadanRouteImport } from './routes/delegowanie-zadan'
import { Route as GaleriaZdjecRouteImport } from './routes/galeria-zdjec'
import { Route as KonfliktZeWspolnikiemRouteImport } from './routes/konflikt-ze-wspolnikiem'
import { Route as KonsultacjeRouteImport } from './routes/konsultacje'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as MastermindRouteImport } from './routes/mastermind'
import { Route as MastermindDlaPrzedsiebiorcowRouteImport } from './routes/mastermind-dla-przedsiebiorcow'
import { Route as MediaIPublikacjeRouteImport } from './routes/media-i-publikacje'
import { Route as OMnieRouteImport } from './routes/o-mnie'
import { Route as PanelSeoRouteImport } from './routes/panel-seo'
import { Route as PanelSeoAsystentRouteImport } from './routes/panel-seo-asystent'
import { Route as PerfekcjonizmRouteImport } from './routes/perfekcjonizm'
import { Route as PodcastRouteImport } from './routes/podcast'
import { Route as PolitykaPrywatnosciRouteImport } from './routes/polityka-prywatnosci'
import { Route as PsychologiaBiznesuRouteImport } from './routes/psychologia-biznesu'
import { Route as PsychologiaPrzywodztwaRouteImport } from './routes/psychologia-przywodztwa'
import { Route as RezerwacjaRouteImport } from './routes/rezerwacja'
import { Route as SamotnoscLideraRouteImport } from './routes/samotnosc-lidera'
import { Route as SeoIndeksowanieRouteImport } from './routes/seo-indeksowanie'
import { Route as SeoPreviewRouteImport } from './routes/seo-preview'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as StawianieGranicWPracyRouteImport } from './routes/stawianie-granic-w-pracy'
import { Route as StresWPracyADecyzjeRouteImport } from './routes/stres-w-pracy-a-decyzje'
import { Route as SyndromOszustaRouteImport } from './routes/syndrom-oszusta'
import { Route as TestNaWypalenieZawodoweRouteImport } from './routes/test-na-wypalenie-zawodowe'
import { Route as WypalenieZawodoweULideraRouteImport } from './routes/wypalenie-zawodowe-u-lidera'
import { Route as WystapieniaRouteImport } from './routes/wystapienia'
import { Route as KoncepcjeIndexRouteImport } from './routes/koncepcje/index'
import { Route as KoncepcjeIdRouteImport } from './routes/koncepcje/$id'
import { Route as MindmasterSplatRouteImport } from './routes/mindmaster.$'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DelegowanieZadanRoute = DelegowanieZadanRouteImport.update({
            id: '/delegowanie-zadan',path: '/delegowanie-zadan',getParentRoute: () => rootRouteImport
          })
const GaleriaZdjecRoute = GaleriaZdjecRouteImport.update({
            id: '/galeria-zdjec',path: '/galeria-zdjec',getParentRoute: () => rootRouteImport
          })
const KonfliktZeWspolnikiemRoute = KonfliktZeWspolnikiemRouteImport.update({
            id: '/konflikt-ze-wspolnikiem',path: '/konflikt-ze-wspolnikiem',getParentRoute: () => rootRouteImport
          })
const KonsultacjeRoute = KonsultacjeRouteImport.update({
            id: '/konsultacje',path: '/konsultacje',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const MastermindRoute = MastermindRouteImport.update({
            id: '/mastermind',path: '/mastermind',getParentRoute: () => rootRouteImport
          })
const MastermindDlaPrzedsiebiorcowRoute = MastermindDlaPrzedsiebiorcowRouteImport.update({
            id: '/mastermind-dla-przedsiebiorcow',path: '/mastermind-dla-przedsiebiorcow',getParentRoute: () => rootRouteImport
          })
const MediaIPublikacjeRoute = MediaIPublikacjeRouteImport.update({
            id: '/media-i-publikacje',path: '/media-i-publikacje',getParentRoute: () => rootRouteImport
          })
const OMnieRoute = OMnieRouteImport.update({
            id: '/o-mnie',path: '/o-mnie',getParentRoute: () => rootRouteImport
          })
const PanelSeoRoute = PanelSeoRouteImport.update({
            id: '/panel-seo',path: '/panel-seo',getParentRoute: () => rootRouteImport
          })
const PanelSeoAsystentRoute = PanelSeoAsystentRouteImport.update({
            id: '/panel-seo-asystent',path: '/panel-seo-asystent',getParentRoute: () => rootRouteImport
          })
const PerfekcjonizmRoute = PerfekcjonizmRouteImport.update({
            id: '/perfekcjonizm',path: '/perfekcjonizm',getParentRoute: () => rootRouteImport
          })
const PodcastRoute = PodcastRouteImport.update({
            id: '/podcast',path: '/podcast',getParentRoute: () => rootRouteImport
          })
const PolitykaPrywatnosciRoute = PolitykaPrywatnosciRouteImport.update({
            id: '/polityka-prywatnosci',path: '/polityka-prywatnosci',getParentRoute: () => rootRouteImport
          })
const PsychologiaBiznesuRoute = PsychologiaBiznesuRouteImport.update({
            id: '/psychologia-biznesu',path: '/psychologia-biznesu',getParentRoute: () => rootRouteImport
          })
const PsychologiaPrzywodztwaRoute = PsychologiaPrzywodztwaRouteImport.update({
            id: '/psychologia-przywodztwa',path: '/psychologia-przywodztwa',getParentRoute: () => rootRouteImport
          })
const RezerwacjaRoute = RezerwacjaRouteImport.update({
            id: '/rezerwacja',path: '/rezerwacja',getParentRoute: () => rootRouteImport
          })
const SamotnoscLideraRoute = SamotnoscLideraRouteImport.update({
            id: '/samotnosc-lidera',path: '/samotnosc-lidera',getParentRoute: () => rootRouteImport
          })
const SeoIndeksowanieRoute = SeoIndeksowanieRouteImport.update({
            id: '/seo-indeksowanie',path: '/seo-indeksowanie',getParentRoute: () => rootRouteImport
          })
const SeoPreviewRoute = SeoPreviewRouteImport.update({
            id: '/seo-preview',path: '/seo-preview',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const StawianieGranicWPracyRoute = StawianieGranicWPracyRouteImport.update({
            id: '/stawianie-granic-w-pracy',path: '/stawianie-granic-w-pracy',getParentRoute: () => rootRouteImport
          })
const StresWPracyADecyzjeRoute = StresWPracyADecyzjeRouteImport.update({
            id: '/stres-w-pracy-a-decyzje',path: '/stres-w-pracy-a-decyzje',getParentRoute: () => rootRouteImport
          })
const SyndromOszustaRoute = SyndromOszustaRouteImport.update({
            id: '/syndrom-oszusta',path: '/syndrom-oszusta',getParentRoute: () => rootRouteImport
          })
const TestNaWypalenieZawodoweRoute = TestNaWypalenieZawodoweRouteImport.update({
            id: '/test-na-wypalenie-zawodowe',path: '/test-na-wypalenie-zawodowe',getParentRoute: () => rootRouteImport
          })
const WypalenieZawodoweULideraRoute = WypalenieZawodoweULideraRouteImport.update({
            id: '/wypalenie-zawodowe-u-lidera',path: '/wypalenie-zawodowe-u-lidera',getParentRoute: () => rootRouteImport
          })
const WystapieniaRoute = WystapieniaRouteImport.update({
            id: '/wystapienia',path: '/wystapienia',getParentRoute: () => rootRouteImport
          })
const KoncepcjeIndexRoute = KoncepcjeIndexRouteImport.update({
            id: '/koncepcje/',path: '/koncepcje/',getParentRoute: () => rootRouteImport
          })
const KoncepcjeIdRoute = KoncepcjeIdRouteImport.update({
            id: '/koncepcje/$id',path: '/koncepcje/$id',getParentRoute: () => rootRouteImport
          })
const MindmasterSplatRoute = MindmasterSplatRouteImport.update({
            id: '/mindmaster/$',path: '/mindmaster/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,DelegowanieZadanRoute: DelegowanieZadanRoute,GaleriaZdjecRoute: GaleriaZdjecRoute,KonfliktZeWspolnikiemRoute: KonfliktZeWspolnikiemRoute,KonsultacjeRoute: KonsultacjeRoute,KontaktRoute: KontaktRoute,MastermindRoute: MastermindRoute,MastermindDlaPrzedsiebiorcowRoute: MastermindDlaPrzedsiebiorcowRoute,MediaIPublikacjeRoute: MediaIPublikacjeRoute,OMnieRoute: OMnieRoute,PanelSeoRoute: PanelSeoRoute,PanelSeoAsystentRoute: PanelSeoAsystentRoute,PerfekcjonizmRoute: PerfekcjonizmRoute,PodcastRoute: PodcastRoute,PolitykaPrywatnosciRoute: PolitykaPrywatnosciRoute,PsychologiaBiznesuRoute: PsychologiaBiznesuRoute,PsychologiaPrzywodztwaRoute: PsychologiaPrzywodztwaRoute,RezerwacjaRoute: RezerwacjaRoute,SamotnoscLideraRoute: SamotnoscLideraRoute,SeoIndeksowanieRoute: SeoIndeksowanieRoute,SeoPreviewRoute: SeoPreviewRoute,SitemapRoute: SitemapRoute,StawianieGranicWPracyRoute: StawianieGranicWPracyRoute,StresWPracyADecyzjeRoute: StresWPracyADecyzjeRoute,SyndromOszustaRoute: SyndromOszustaRoute,TestNaWypalenieZawodoweRoute: TestNaWypalenieZawodoweRoute,WypalenieZawodoweULideraRoute: WypalenieZawodoweULideraRoute,WystapieniaRoute: WystapieniaRoute,KoncepcjeIdRoute: KoncepcjeIdRoute,MindmasterSplatRoute: MindmasterSplatRoute,KoncepcjeIndexRoute: KoncepcjeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)